"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RC_PEDAL_RICKSHAW_LOADING_REHRI = exports.RC_PEDAL_RICKSHAW_LOADING_REHRI = "CTL.REHRI_REGISTRATION";
var DL_PEDAL_RICKSHAW_LOADING_REHRI = exports.DL_PEDAL_RICKSHAW_LOADING_REHRI = "CTL.REHRI_DRIVING_LICENSE";
var LICENSE_DHOBI_GHAT = exports.LICENSE_DHOBI_GHAT = "CTL.DHOBI_GHAT";
var RENEWAL_RENT_DEED_SHOP = exports.RENEWAL_RENT_DEED_SHOP = "CTL.OLD_BOOK_MARKET";
var REHRI_REGISTRATION = exports.REHRI_REGISTRATION = "CTL_REHRI_REGISTRATION";
var REHRI_DRIVING = exports.REHRI_DRIVING = "CTL_REHRI_DRIVING_LICENSE";
var DHOBI_GHAT = exports.DHOBI_GHAT = "CTL_DHOBI_GHAT";
var OLD_BOOK_MARKET = exports.OLD_BOOK_MARKET = "CTL_OLD_BOOK_MARKET";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-tradelicence/ui-constants/index.js
// module id = 2227
// module chunks = 1143